import { EvaluationTime } from "@redotech/redo-return-core-common/return-flow/condition-enums";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

const shopifyMetafieldToDisplayInPortalSchema_ = z.object({
  namespace: z.string().min(1),
  key: z.string().min(1),
  evaluationTime: createEnum(EvaluationTime),
});

export const shopifyMetafieldToDisplayInPortalSchema: z.ZodType<ShopifyMetafieldToDisplayInPortal> =
  shopifyMetafieldToDisplayInPortalSchema_;
export interface ShopifyMetafieldToDisplayInPortal extends z.infer<
  typeof shopifyMetafieldToDisplayInPortalSchema_
> {}
